import { render, staticRenderFns } from "./DealsItems.vue?vue&type=template&id=bb3802d8&"
import script from "./DealsItems.vue?vue&type=script&lang=js&"
export * from "./DealsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports